export * from '@src/components/templates/occl/forTesting.tmpl.js';
export * from '@src/components/templates/occl/TefComs4cs4p/index.js';
export * from '@src/components/templates/occl/tefComsButton.tmpl.js';
export * from '@src/components/templates/occl/tefComsCancelButton.tmpl.js';
export * from '@src/components/templates/occl/tefComsLoader.tmpl.js';
export * from '@src/components/templates/occl/tefComsSaveButton.tmpl.js';
